import styled from 'styled-components';

import { Container as AppContainer } from '@/styles';

export const Container = styled(AppContainer)`
  max-width: 994px;
  padding: 0 2rem;
`;

export const Content = styled.div`
  margin: 10rem 0 13rem;

  @media (max-width: 640px) {
    margin: 6rem 0;
  }
`;

export const PageTitle = styled.h1`
  font-weight: 600;
  font-size: 3.6rem;
  line-height: 5.4rem;
  color: ${({ theme }) => theme.color.primary};
  text-align: center;

  @media (max-width: 640px) {
    font-size: 2.3rem;
    line-height: 3.45rem;
  }
`;

export const HelpItemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 15.6rem;
  row-gap: 8.5rem;

  @media (max-width: 1024px) {
    column-gap: 8.5rem;
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;
